<script setup>
import Icon from '../Icon.vue';
import { useConfiguratorStore } from '../../stores/configurator';
import { ROOM_SIDE_CORRIDOR } from '../../constants/roomSides.js';
import { useSubmitStore } from '../../stores/submit.js';
import { useUiStore } from '../../stores/ui.js';

const configurationStore = useConfiguratorStore();
const submitStore = useSubmitStore();
const uiStore = useUiStore();
</script>

<template>
    <div
        class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-absolute tw-mb-3 lg:tw-mb-0 tw-left-3 tw-right-3 tw-h-10 xl:tw-h-12 md:tw-pb-0 md:tw-left-5 md:tw-right-5 lg:tw-pb-0 lg:tw-left-6 lg:tw-right-6 tw-z-50 tw-transition-all tw-duration-300"
        :class="[!uiStore.isScrollingUp || uiStore.showDetails || uiStore.showOverlayConfig ? 'tw-bottom-[calc(50vw+3px)] lg:tw-bottom-5' : 'tw-bottom-0 lg:tw-bottom-5']"
        v-if="uiStore.currentStepIndex > 0 && !submitStore.isFinished"
    >
        <div class="tw-w-full tw-flex-row-reverse tw-h-full md:tw-w-auto tw-flex tw-items-center lg:tw-flex-row tw-justify-start md:tw-justify-between tw-gap-4 tw-transition-all tw-duration-300">
                <span
                    v-if="!uiStore.showOverlayConfig"
                    class="btn btn-configurator-circle rounded white !tw-py-0 tw-h-8 tw-text-brand-500 tw-flex tw-items-center tw-justify-center tw-aspect-square tw-shadow-configuratorBtn md:tw-aspect-unset md:tw-shadow-none md:tw-h-full"
                    @click="uiStore.toggleOverlayConfig('room'); uiStore.showDetails = false"
                >
                    <Icon name="room" class="tw-size-5" />
                    <span class="tw-hidden md:tw-inline-block tw-ml-2" v-t="`website.configurator.toggle_room`"></span>
                </span>

                <span
                    v-if="!uiStore.showOverlayConfig"
                    class="btn btn-configurator-circle rounded white !tw-py-0 tw-h-8 tw-text-brand-500 tw-flex tw-items-center tw-justify-center tw-aspect-square tw-shadow-configuratorBtn md:tw-aspect-unset md:tw-shadow-none md:tw-h-full"
                    @click="uiStore.toggleOverlayConfig('floor'); uiStore.showDetails = false"
                >
                    <Icon name="floor" class="tw-size-5" />
                    <span class="tw-hidden md:tw-inline-block tw-ml-2" v-t="`website.configurator.toggle_floor`"></span>
                </span>

                <span
                    v-if="uiStore.showOverlayConfig"
                    class="btn btn-configurator-circle rounded white !tw-py-0 tw-h-8 tw-text-brand-500 tw-flex tw-items-center tw-justify-center tw-aspect-square tw-shadow-configuratorBtn md:tw-aspect-unset md:tw-shadow-none md:tw-h-full"
                    :class="{'tw-text-gray-700 !tw-px-2 xl:!tw-px-3 md:tw-aspect-square lg:tw-border lg:tw-border-gray-100 hover:tw-border-brand-500': uiStore.showOverlayConfig}"
                    @click="uiStore.showOverlayConfig = false; uiStore.showRoomConfig = false; uiStore.showFloorConfig = false; uiStore.showDetails = false"
                >
                    <Icon name="close" class="tw-size-6" />
                </span>


            <span
                class="btn btn-configurator-pill rounded white !tw-py-0 tw-h-8 tw-text-brand-500 tw-flex tw-items-center tw-justify-start tw-space-x-2 md:tw-h-full"
                :class="{'lg:tw-border lg:tw-border-gray-100 hover:tw-border-brand-500': uiStore.showRoomConfig}"
                @click="configurationStore.toggleRoomSide()"
            >
                <Icon name="swap" class="tw-size-5 lg:tw-size-6" />
                <span v-t="configurationStore.configuration.roomSide === ROOM_SIDE_CORRIDOR ? 'website.configurator.room' : 'website.configurator.corridor'"></span>
            </span>
        </div>

        <div class="tw-hidden tw-h-full lg:tw-block">
            <span
                class="btn btn-configurator-pill rounded white !tw-py-0 tw-h-full tw-text-brand-500 tw-flex tw-items-center tw-justify-center "
                v-if="uiStore.details"
                @click="uiStore.showDetails = !showDetails, uiStore.showRoomConfig = false"
                :class="{'tw-text-gray-700 tw-aspect-square !tw-px-0': uiStore.showDetails}"
            >
                <Icon v-if="!uiStore.showDetails" name="info" class="tw-size-6" />
                <Icon v-if="uiStore.showDetails" name="close" class="tw-size-6" />
                <span v-if="!uiStore.showDetails" class="tw-ml-2" v-t="`website.configurator.details`"></span>
            </span>
        </div>
    </div>
</template>